var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Formik } from 'formik';
import React, { useEffect, useRef } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import styled from 'styled-components';
import { diff } from '../lib/diff';
const StyledErrorBox = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  .error-title {
    margin: 10px 0 5px 0;
    color: ${props => props.theme.palette.error.main};
  }
  .error-body {
    margin-bottom: 10px;
  }
  code {
    font-size: 10px;
    color: #999;
  }
`;
export function InlineFormik(props) {
    const { children, innerRef, initialValues, isSubmitting, error, onSubmit } = props, remainingProps = __rest(props, ["children", "innerRef", "initialValues", "isSubmitting", "error", "onSubmit"]);
    const formikRef = useRef();
    // make a copy of the initialValues for use when comparing changes;
    // cached values are updated prior to submitting to retain changes;
    // we don't want to keep updating initialValues as that will cause
    // UI re-render.
    const initialValuesRef = useRef(initialValues);
    const cachedValuesRef = useRef();
    // const [cachedValues, setCachedValues] = useState(initialValues);
    useEffect(() => {
        // updated cached values if initial values change
        if (!cachedValuesRef.current ||
            JSON.stringify(initialValuesRef.current) !== JSON.stringify(initialValues)) {
            initialValuesRef.current = initialValues;
            cachedValuesRef.current = initialValues;
        }
    }, [initialValues]);
    useEffect(() => {
        if (formikRef && formikRef.current) {
            formikRef.current.setSubmitting(isSubmitting || false);
        }
    }, [isSubmitting]);
    return error ? (
    // Display Error
    React.createElement(StyledErrorBox, null,
        React.createElement(ReportProblemIcon, { fontSize: 'large', color: 'error' }),
        React.createElement(Typography, { variant: 'h5', className: 'error-title' }, "An error occurred!"),
        React.createElement(Typography, { variant: 'body1', className: 'error-body' }, "There was a problem loading the form. Please reload the browser and try again."),
        error.message && (React.createElement("code", null,
            React.createElement("u", null, "Error"),
            ": ",
            error.message)),
        error.error && (React.createElement("code", null, error.error)))) : initialValues ? (React.createElement(Formik, Object.assign({ innerRef: formik => {
            // keep a reference of the formik object
            formikRef.current = formik;
            // forward the formik object if needed
            if (innerRef)
                innerRef(formik);
        }, enableReinitialize: true, initialValues: initialValues, onSubmit: (values, formikHelpers) => {
            const cachedValues = cachedValuesRef.current;
            const valuesDiff = diff(cachedValues, values);
            if (valuesDiff) {
                // set the cached values to prevent resubmitting the form; this
                // helps if saving is slow and user is making fast changes
                cachedValuesRef.current = values;
                // only submit diff changes for inline form sbimission
                onSubmit(valuesDiff, formikHelpers);
            }
            else if (formikRef && formikRef.current) {
                // if no value changes don't submit anything
                formikRef.current.setSubmitting(false);
            }
        } }, remainingProps), children)) : (React.createElement(CircularProgress, null));
}
//# sourceMappingURL=InlineFormik.js.map